import { CSSProperties, PropsWithChildren, ReactElement } from 'react';
import { List, styled } from '@mui/material';

const Wrapper = styled(List)(({ theme }) => ({
    ...theme.typography['body1'],
    padding: 0,
    listStyleType: 'none',
    minWidth: 'unset',
}));

interface FooterColumnProps extends PropsWithChildren {
    position?: CSSProperties['textAlign'];
}

export const FooterColumn = (props: FooterColumnProps): ReactElement => <Wrapper {...props} />;
